import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import downGreenChevron from "../../images/down-green-chevron.png";

import {updateMarketWheel, changeValue, fetchQuarterPeriods, setVal, setSelectedQuarter} from "../../actions";

class QuarterPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            currentIndex: this.props.selectedQuarterIndex
        }
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    changeValue(idx) {
        this.setState({currentIndex: idx}, () => {
            this.updateWheel()
        });
    }

    disableForward() {
        return (this.state.currentIndex === 0) ? true : false;
    }

    disableBackward() {
        return (this.state.currentIndex === this.props.quarterPeriods.length - 1) ? true : false;
    }

    forward() {
        if(!this.disableForward()){
            this.setState({currentIndex: this.state.currentIndex - 1}, () => {
                this.updateWheel()
            });
        }
    }

    backward() {
        if(!this.disableBackward()){
            this.setState({currentIndex: this.state.currentIndex + 1}, () => {
                this.updateWheel()
            });
        }
    }

    updateWheel() {
        const { displayCities, lookup, position,
                quarterPeriods, sectorColor, sectorText,
                selectedWheelPosition, setSelectedQuarter,
                setVal, updateMarketPosition, updateMarketWheel,
                updateSVGDimensions } = this.props;
        const selectedQuarter = quarterPeriods[this.state.currentIndex];
        const selectedIndex = lookup[selectedQuarter];

        updateMarketPosition('', selectedIndex);
        setVal(selectedWheelPosition,selectedWheelPosition);
        updateMarketWheel(selectedIndex);
        setSelectedQuarter(this.state.currentIndex);

        if(updateSVGDimensions) {
            updateSVGDimensions();
        }

        if (position){
            if(displayCities) {
                displayCities(sectorText, position, sectorColor);
            }
        }
}

    componentDidMount() {
        this.props.fetchQuarterPeriods();
    }

    render() {
        const { selectedQuarterIndex, quarterPeriods } = this.props;
        const currentQuarter = quarterPeriods.length > 0 ? quarterPeriods[selectedQuarterIndex] : 'loading...';
         return (
            <div className={`quarter-picker-wrapper`}  onClick={() => this.toggle()}>
                <Dropdown className={'quarter-picker-toggle'} isOpen={this.state.dropdownOpen} toggle={() => this.toggle()}>
                    <DropdownToggle id={'quarter-picker-toggle-nav'} className='quarter-picker-toggle'>
                        {currentQuarter}
                    </DropdownToggle>
                    <DropdownMenu className='quarter-picker-menu'>
                        {quarterPeriods.map((quarterPeriod,idx) =>
                            <DropdownItem id={'btnQuarter' +idx} className='quarter-picker-menu-item' key={idx} onClick={() => this.changeValue(idx)}>{quarterPeriod}</DropdownItem>
                        )}
                    </DropdownMenu>
                </Dropdown>
                <span className={`arrow-nav float-right quarter-picker-arrowposition`}><img src={downGreenChevron} alt="downArrow" height="10" width="15"/></span>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedQuarterIndex: state.quarterPeriods.currentQuarterIndex,
        quarterPeriods: state.quarterPeriods.quarterPeriodList,
        lookup: state.quarterPeriods.lookup,
        selectedRegion: state.greaterRegions,
        selectedDefinition: state.selectedWheelPosition.selectedDefinition,
        selectedWheelPosition : state.selectedWheelPosition.selectedWheelPosition,
        selected : state.selected
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchQuarterPeriods: () => {
            dispatch(fetchQuarterPeriods())
        },
        updateMarketWheel: (selectedIndex) => {
            dispatch(updateMarketWheel(selectedIndex))
        },
        updateMarketPosition: (marketid, positionid) => {
            dispatch(changeValue(marketid, positionid))
        },
        setVal:(selectedDefinition, selectedWheelPosition) => {
            dispatch(setVal(selectedDefinition, selectedWheelPosition))
        },
        setSelectedQuarter: (selectedIndex) => {
            dispatch(setSelectedQuarter(selectedIndex))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuarterPicker);